import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStudioDisplay1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"studio-display, xdr, imac"} maskId="square-filled-radius-0-stroke-1-IconStudioDisplay1"><path d="M9 17H15V21H9V17Z" fill="currentColor"/><rect x="2" y="3" width="20" height="13" fill="currentColor"/></CentralIconBase>;
}));

export default IconStudioDisplay1;
